import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Utilities } from '../../../shared/services/utilities';

@Component({
    selector: 'app-pragmatic-grid-column',
    templateUrl: './pragmatic-grid-column.component.html',
    styleUrls: ['./pragmatic-grid-column.component.scss'],
    standalone: false
})

export class PragmaticGridColumnComponent implements OnInit {
    @Input() data!:any;
    @Output() onDownload = new EventEmitter<any>();
    formatOptions: { type: string; format: string; };

    ngOnInit(): void {
        this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() };
    }

    downloadFile(filePath: string, fileName: string) {
        this.onDownload.emit({filePath, fileName});
    }
}
